<script lang="ts">
	import type { ClassValue } from 'svelte/elements';
	import type { PartnerLinkProps } from './types';
	import { generateRandomNumber } from '$lib/components/advertising/utils';
	import Image from '$lib/components/atoms/image/Image.svelte';

	interface Props {
		data: PartnerLinkProps;
		class?: ClassValue;
		onclick?: () => void;
	}

	const { data, class: classes, onclick }: Props = $props();
	const { label, enabled, hover, focus, pressed, radius, impressionUrl } = $derived(data);
</script>

<button
	class={['partner-link', classes, 'h-auto px-3 py-2 text-md inline-block cursor-pointer border-0']}
	style="--radius:{radius}px;
		--enabled-label-color:{enabled.label};
			--enabled-bg-color:{enabled.bg};
			--enabled-shadow-color:{enabled.boxShadow};
			--hover-label-color:{hover.label};
			--hover-bg-color:{hover.bg};
			--hover-shadow-color:{hover.boxShadow};
			--focus-label-color:{focus.label};
			--focus-bg-color:{focus.bg};
			--focus-shadow-color:{focus.boxShadow};
			--pressed-label-color:{pressed.label};
			--pressed-bg-color:{pressed.bg};
			--pressed-shadow-color:{pressed.boxShadow};"
	{onclick}
>
	{label}
</button>

{#if impressionUrl}
	<Image
		src={impressionUrl.replace('{{randomId}}', generateRandomNumber().toString())}
		width="1"
		height="1"
		alt=""
	/>
{/if}

<style>
	.partner-link {
		border-radius: var(--radius) !important;
		background-color: var(--enabled-bg-color) !important;
		box-shadow: 0px 3px 0px 0px var(--enabled-shadow-color) !important;
		color: var(--enabled-label-color) !important;
	}
	.partner-link:hover {
		background-color: var(--hover-bg-color) !important;
		box-shadow: 0px 3px 0px 0px var(--hover-shadow-color) !important;
		color: var(--hover-label-color);
	}
	.partner-link:active {
		background-color: var(--pressed-bg-color) !important;
		box-shadow: 0px 3px 0px 0px var(--pressed-shadow-color) !important;
		color: var(--pressed-label-color) !important;
	}
	.partner-link:focus {
		background-color: var(--focus-bg-color) !important;
		box-shadow: 0px 3px 0px 0px var(--focus-shadow-color) !important;
		color: var(--focus-label-color) !important;
	}
</style>
